import Cookies from "js-cookie";

// const tokenFromCookies = Cookies.get("token");
// const customerIdFromCookies = JSON.parse(
//   Cookies.get("decodedToken")
// ).customerid;

// const getCustomerId = () => {
//   const decodedToken = Cookies.get("decodedToken");
//   if (!decodedToken) return null;

//   try {
//     return JSON.parse(decodedToken)?.customerid || null;
//   } catch (error) {
//     console.error("Error parsing cookie:", error);
//     return null;
//   }
// };

// const customerIdFromCookies = getCustomerId();

const tokenFromCookies = Cookies.get("token");

const decodedToken = Cookies.get("decodedToken"); // Get raw cookie value
const parsedToken = decodedToken ? JSON.parse(decodedToken) : null; // Parse only if exists

const customerIdFromCookies = parsedToken ? parsedToken.customerid : null;
const userIdFromCookies = parsedToken ? parsedToken.unique_name : null;

// Function to get token dynamically
export const GetToken = () =>
  Cookies.get("token") || window.localStorage.getItem("token");

// Function to get decoded token dynamically
export const GetDecodedToken = () => {
  const decodedToken = Cookies.get("decodedToken");
  return decodedToken ? JSON.parse(decodedToken) : null;
};

// Function to get customerId dynamically
export const GetCustomerId = () => {
  const parsedToken = GetDecodedToken();
  return (
    localStorage.getItem("customerId") ||
    (parsedToken ? parsedToken.customerid : "")
  );
};

// Function to get userId dynamically
export const GetUserId = () => {
  const parsedToken = GetDecodedToken();
  return (
    localStorage.getItem("userId") ||
    (parsedToken ? parsedToken.unique_name : "")
  );
};

const BASEURL = `${process.env.REACT_APP_API_BASE_URL}`;
//Qa url
// const BASEURL = "https://api-qa.rooftopmeasurements.com/";
// const BASEURL = "https://api-beta.rooftopmeasurements.com/";
//production url
// const BASEURL = "https://api.rooftopmeasurements.com/";
const GET_USER_Details = `${BASEURL}customers`;
const GET_ORDER_HISTORY = `${BASEURL}orders/get-orders-history`;
const USERID = localStorage.getItem("userId");
const CUSTOMERID =
  window.localStorage.getItem("customerId") || customerIdFromCookies
    ? customerIdFromCookies
    : null;
const TOKEN = window.localStorage.getItem("token") || tokenFromCookies;
const ADD_CC_EMAILS = `${BASEURL}customers/ccemails`;
const GET_CC_EMAILS = () => `${BASEURL}customers/${GetCustomerId()}/cc-emails`;
const GET_ALL_SAVED_CARD_DETAILS = `${BASEURL}customers/getcustomerentity`;
const POST_PAYPAL_TRANSACTION = `${BASEURL}orders/transaction`;
const POST_ORDER_REPORTS = `${BASEURL}orders/customer-portal`;
const POST_ORDER_CREDITS = `${BASEURL}customerbricks/customer-portal`;
const ADD_CARD_DETAILS = `${BASEURL}paymentcards/add-card`;
const REMOVE_SAVED_CARD_DETAILS = `${BASEURL}paymentcards/delete-card/`;
const SECRET_KEY = `G7Y9bD4gE8uPjV6L0rF1zP2yQkK3T0Z7`;
const IV_KEY = `L0kHjYq9F1vBzNwM`;
const POST_PAYPAL_PAYMENT = `${BASEURL}orders/transaction`;
const UPDATE_EMAIL = `${BASEURL}customers/update-email`;
const REGISTER_USER = `${BASEURL}customers`;
export {
  REGISTER_USER,
  GET_USER_Details,
  GET_ORDER_HISTORY,
  POST_PAYPAL_PAYMENT,
  USERID,
  CUSTOMERID,
  BASEURL,
  GET_CC_EMAILS,
  ADD_CC_EMAILS,
  GET_ALL_SAVED_CARD_DETAILS,
  POST_PAYPAL_TRANSACTION,
  POST_ORDER_CREDITS,
  POST_ORDER_REPORTS,
  ADD_CARD_DETAILS,
  REMOVE_SAVED_CARD_DETAILS,
  SECRET_KEY,
  IV_KEY,
  UPDATE_EMAIL,
  TOKEN,
};
